import React from "react";
import { MembersDataTable } from "./";

const MembersPage = () => {
  return (
    <div className="sub-content">
      <MembersDataTable />
    </div>
  );
};

export default MembersPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/MembersPage.js